export const LOGIN_REQUEST = (state) => {
  state.status = 'loggingIn';
};

export const LOGIN_SUCCESS = (state, val) => {
  state.status = 'loggedIn';
  state.access.token = val.access_token;
  state.access.expire = val.expire_at;
  state.access.refresh_token = val.refresh_token;
  state.user = val.account;
};

export const LOGIN_UPDATE = (state, val) => {
  state.access.token = val.access_token;
  state.access.expire = val.expire_at;
  state.user = val.account;
};

export const LOGIN_FAIL = (state) => {
  state.status = 'logging failed';
  state.user = {};
//  state.userAccount = {};
};

export const LOGOUT = (state) => {
  state.status = '';
  state.access = {};
  state.user = {};
//  state.userAccount = {};
};
